import Icon from '../components/Icon.vue'

Icon.register({
  clone: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 0c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h288zM176 416h208v48c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h48v208c0 44.1 35.9 80 80 80z'
      }
    ]
  }
})
